import { gql } from 'graphql-tag'

export const fetchStationsList = gql`
  query FetchStationList($after: String, $first: Int) {
    stations(after: $after, first: $first) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`

export const fetchEmployeesList = gql`
  query FetchEmployeeList($stationId: ID!) {
    employees(stationId: $stationId) {
      edges {
        node {
          id
          user {
            id
            name
          }
        }
      }
    }
  }
`

export const fetchMonthlyFeelingReport = gql`
  query FetchMonthlyFeelingReport($stationId: ID!, $employeeId: ID, $year: Int, $month: Int) {
    reportMonthlyFeelingMeter(stationId: $stationId, employeeId: $employeeId, year: $year, month: $month) {
      yearAverage
      monthAverage
      month
      year
      weekAverages {
        week
        weekAverage
        weeklyEmployees
        weeklyFeedbacks
        weeklyFeelingMeters
      }
      byDay {
        date
        dayAverage
        feedbackNumber
        employeesNumber
        notesNumber
        feelingMetersNumber
      }
      monthlyTotalEmployees
      monthlyTotalFeedbacks
      monthlyTotalFeelingMeters
    }
  }
`
export const fetchFeelingMeterDetails = gql`
  query FetchFeelingMeterDetails($stationId: ID!, $employeeId: ID, $date: String) {
    reportFeelingMeterDetails(stationId: $stationId, employeeId: $employeeId, date: $date) {
      date
      note
      shift
      hasFeedback
      feeling
      user {
        name
      }
    }
  }
`
